import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

const SocialLinksForm = ({ show, handleClose, onSocialLinkAdded, editingIndex, socialLinks }) => {
  const [formData, setFormData] = useState({
    name: '',
    url: '',
    image: null,
    imagePreview: ''
  });

  useEffect(() => {
    if (editingIndex !== null && socialLinks[editingIndex]) {
      const link = socialLinks[editingIndex];
      setFormData({
        name: link.name || '',
        url: link.link || '',
        image: null,
        imagePreview: link.image || ''
      });
    } else {
      setFormData({
        name: '',
        url: '',
        image: null,
        imagePreview: ''
      });
    }
  }, [editingIndex, socialLinks, show]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        toast.error('Image size should be less than 2MB');
        e.target.value = ''; // Clear the input
        return;
      }
      
      // Validate file type - only PNG allowed
      // if (file.type !== 'image/png') {
      //   toast.error('Only PNG images are allowed');
      //   e.target.value = ''; // Clear the input
      //   return;
      // }

      setFormData(prev => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file)
      }));
    }
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error('Please enter platform name');
      return false;
    }
    
    if (!formData.url.trim()) {
      toast.error('Please enter URL');
      return false;
    }
    
    // Basic URL validation
    try {
      new URL(formData.url);
    } catch {
      toast.error('Please enter a valid URL');
      return false;
    }
    
    // Check if image is required (for new entries) or if user uploaded a new image
    if (editingIndex === null && !formData.image && !formData.imagePreview) {
      toast.error('Please upload a PNG image');
      return false;
    }
    
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    onSocialLinkAdded(formData);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="border-0 mt-4 pt-0 pb-2">
        <div className="d-flex justify-content-center w-100">
          <Modal.Title className='h4'>
            {editingIndex !== null ? 'Edit Social Link' : 'Add Social Link'}
          </Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body className='px-md-4'>
        <form onSubmit={handleSubmit} className="form-login">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Platform Name <span className="text-danger">*</span></label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-control"
                placeholder="e.g., Facebook, Instagram"
                required
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="form-label">URL <span className="text-danger">*</span></label>
              <input
                type="url"
                name="url"
                value={formData.url}
                onChange={handleInputChange}
                className="form-control"
                placeholder="https://example.com"
                required
              />
            </div>
            
            <div className="col-md-12 mb-3">
              <label className="form-label">
                Icon/Image 
                {editingIndex === null && <span className="text-danger">*</span>}
              </label>
              <input
                type="file"
                onChange={handleImageChange}
                className="form-control"
                required={editingIndex === null}
              />
              <small className="text-muted">
                {editingIndex !== null 
                  ? 'Leave empty to keep existing image. Only PNG format allowed (Max 2MB)' 
                  : 'Upload a PNG image for the social link (Max 2MB)'
                }
              </small>
            </div>
            
            {/* Image Preview */}
            {formData.imagePreview && (
              <div className="col-md-12 mb-3">
                <label className="form-label">Preview:</label>
                <div>
                  <img 
                    src={formData.imagePreview} 
                    alt="Preview" 
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                    className="border rounded"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="text-center mb-4">
            <button
              type="submit"
              className="btn bg-button py-3 text-white"
              style={{ width: '200px' }}
            >
              {editingIndex !== null ? 'Update' : 'Add'}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default SocialLinksForm; 